import api from './api';

export default class RecadastramentoService {
  constructor() {
    throw 'Não é possível instanciar RecadastramentoService';
  }

  static async lista() {
    const endpoint = mergeEndpoint();
    return await api.get(endpoint);
  }

  static async listaPorAno() {
    const endpoint = mergeEndpoint() + 'mesCompetencia';
    return await api.get(endpoint);
  }

  static async obtemPorId(id) {
    const endpoint = mergeEndpoint(id);
    return await api.get(endpoint);
  }

  static async grava(id, cadastro) {
    const endpoint = mergeEndpoint(id);
    return await api.put(endpoint, cadastro);
  }
}

const mergeEndpoint = id => {
  return `recadastramento-servidores/${id || ''}`;
};



// WEBPACK FOOTER //
// ./src/services/recadastramentoService.js